import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { submitDemoRequest } from '../../../services/api';

const DemoSection = () => {
  const [activeDemo, setActiveDemo] = useState('dashboard');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    businessName: '',
    businessType: '',
    currentSystem: '',
    preferredTime: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const demoTypes = [
    {
      id: 'dashboard',
      title: 'Yönetim Paneli',
      description: 'Gerçek zamanlı dashboard ve raporlama',
      icon: 'BarChart3',
      color: 'bg-blue-500'
    },
    {
      id: 'qr-menu',
      title: 'QR Menü Sistemi',
      description: 'Temassız menü deneyimi',
      icon: 'QrCode',
      color: 'bg-purple-500'
    },
    {
      id: 'pos',
      title: 'POS Sistemi',
      description: 'Hızlı sipariş alma ve ödeme',
      icon: 'CreditCard',
      color: 'bg-green-500'
    },
    {
      id: 'mobile',
      title: 'Mobil Uygulama',
      description: 'iOS ve Android uygulaması',
      icon: 'Smartphone',
      color: 'bg-orange-500'
    }
  ];

  const businessTypes = [
    { value: 'cafe', label: 'Kafe' },
    { value: 'restaurant', label: 'Restoran' },
    { value: 'fastfood', label: 'Fast Food' },
    { value: 'doner', label: 'Dürümcü' },
    { value: 'bakery', label: 'Pastane/Fırın' },
    { value: 'chain', label: 'Zincir Market' },
    { value: 'bistro', label: 'Bistro' },
    { value: 'other', label: 'Diğer' }
  ];

  const currentSystems = [
    { value: 'none', label: 'Hiç sistem kullanmıyorum' },
    { value: 'basic-pos', label: 'Temel POS sistemi' },
    { value: 'paper', label: 'Kağıt bazlı işlemler' },
    { value: 'excel', label: 'Excel ile takip' },
    { value: 'other', label: 'Diğer sistem' }
  ];

  const timeSlots = [
    { value: 'morning', label: 'Sabah (09:00-12:00)' },
    { value: 'afternoon', label: 'Öğleden Sonra (13:00-17:00)' },
    { value: 'evening', label: 'Akşam (18:00-20:00)' }
  ];

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // API call
      await submitDemoRequest(formData);
      setIsSubmitted(true);
    } catch (error) {
      console.error('Demo request failed:', error);
      alert('Demo talebi gönderilirken bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const mockDashboardData = {
    todaySales: '₺2,847',
    activeOrders: 23,
    completedOrders: 156,
    customerSatisfaction: '4.8/5.0',
    topProducts: [
      { name: 'Americano', sales: 45, revenue: '₺315' },
      { name: 'Cheesecake', sales: 23, revenue: '₺460' },
      { name: 'Cappuccino', sales: 38, revenue: '₺342' }
    ],
    recentOrders: [
      { id: '#1247', customer: 'Mehmet K.', items: 'Americano + Cheesecake', amount: '₺45', status: 'Hazırlanıyor' },
      { id: '#1248', customer: 'Ayşe D.', items: 'Cappuccino + Croissant', amount: '₺38', status: 'Teslim Edildi' },
      { id: '#1249', customer: 'Can Y.', items: 'Latte + Muffin', amount: '₺42', status: 'Yeni' }
    ]
  };

  if (isSubmitted) {
    return (
      <section id="demo" className="py-20 bg-gradient-to-br from-green-50 to-blue-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-white rounded-2xl p-12 shadow-xl">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Icon name="CheckCircle" size={40} className="text-green-600" />
            </div>
            
            <h2 className="font-poppins font-heading-bold text-3xl text-foreground mb-4">
              Demo Talebiniz Alındı!
            </h2>
            
            <p className="font-open-sans font-body-normal text-lg text-text-secondary mb-8">
              Uzmanlarımız en kısa sürede sizinle iletişime geçecek ve kişiselleştirilmiş demo sunumunuzu planlayacak.
            </p>
            
            <div className="grid md:grid-cols-2 gap-6 mb-8">
              <div className="bg-blue-50 p-6 rounded-xl">
                <Icon name="Calendar" size={32} className="text-blue-600 mx-auto mb-3" />
                <h3 className="font-poppins font-heading-semibold text-lg text-foreground mb-2">
                  Demo Randevunuz
                </h3>
                <p className="font-open-sans font-body-normal text-text-secondary">
                  24 saat içinde aranacaksınız
                </p>
              </div>
              
              <div className="bg-purple-50 p-6 rounded-xl">
                <Icon name="Gift" size={32} className="text-purple-600 mx-auto mb-3" />
                <h3 className="font-poppins font-heading-semibold text-lg text-foreground mb-2">
                  Özel Teklif
                </h3>
                <p className="font-open-sans font-body-normal text-text-secondary">
                  İlk 3 ay %50 indirim
                </p>
              </div>
            </div>
            
            <div className="bg-gray-50 p-6 rounded-xl">
              <h4 className="font-poppins font-heading-semibold text-lg text-foreground mb-3">
                Demo Sürecinde Neler Olacak?
              </h4>
              <div className="grid md:grid-cols-3 gap-4 text-left">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white text-xs font-bold">1</span>
                  </div>
                  <div>
                    <p className="font-inter font-accent-semibold text-sm text-foreground">
                      İhtiyaç Analizi
                    </p>
                    <p className="font-open-sans font-body-normal text-xs text-text-secondary">
                      İşletmenizin özel ihtiyaçlarını belirleriz
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white text-xs font-bold">2</span>
                  </div>
                  <div>
                    <p className="font-inter font-accent-semibold text-sm text-foreground">
                      Canlı Demo
                    </p>
                    <p className="font-open-sans font-body-normal text-xs text-text-secondary">
                      Sistemi gerçek verilerle test ederiz
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white text-xs font-bold">3</span>
                  </div>
                  <div>
                    <p className="font-inter font-accent-semibold text-sm text-foreground">
                      Özel Teklif
                    </p>
                    <p className="font-open-sans font-body-normal text-xs text-text-secondary">
                      Size özel fiyatlandırma sunarız
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="demo-request" className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-6">
            <Icon name="Play" size={16} />
            <span className="font-inter font-accent-medium text-sm">
              Canlı Demo
            </span>
          </div>
          
          <h2 className="font-poppins font-heading-bold text-3xl md:text-4xl lg:text-5xl text-foreground mb-6">
            Sistemi{' '}
            <span className="text-primary">Canlı Görün</span>
          </h2>
          
          <p className="font-open-sans font-body-normal text-xl text-text-secondary max-w-3xl mx-auto">
            15 dakikalık kişiselleştirilmiş demo ile işletmeniz için mükemmel çözümü keşfedin
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Left - Demo Preview */}
          <div className="space-y-8">
            {/* Demo Type Selector */}
            <div className="flex flex-wrap gap-3">
              {demoTypes.map((demo) => (
                <div key={demo.id} className="flex flex-col space-y-2">
                  <button
                    onClick={() => setActiveDemo(demo.id)}
                    className={`flex items-center space-x-2 px-4 py-3 rounded-xl transition-all duration-300 ${
                      activeDemo === demo.id
                        ? `${demo.color} text-white shadow-lg`
                        : 'bg-white text-text-secondary hover:bg-gray-50 border border-gray-200'
                    }`}
                  >
                    <Icon name={demo.icon} size={20} />
                    <div className="text-left">
                      <div className="font-inter font-accent-semibold text-sm">
                        {demo.title}
                      </div>
                      <div className="font-open-sans font-body-normal text-xs opacity-80">
                        {demo.description}
                      </div>
                    </div>
                  </button>
                  
                  {/* Demo Link Button */}
                  <button
                    onClick={() => {
                      const demoUrl = demo.id === 'dashboard' ? 'https://panel.cafeotomasyonu.com' :
                                     demo.id === 'qr-menu' ? 'https://menu.cafeotomasyonu.com/demo' :
                                     demo.id === 'pos' ? 'https://panel.cafeotomasyonu.com' :
                                     demo.id === 'mobile' ? 'https://online.cafeotomasyonu.com/demo' : 
                                     'https://cafeotomasyonu.com';
                      window.open(demoUrl, '_blank');
                    }}
                    className="flex items-center justify-center space-x-2 px-3 py-2 bg-primary text-white rounded-lg text-sm hover:bg-secondary transition-colors duration-300"
                  >
                    <Icon name="ExternalLink" size={16} />
                    <span>Demo İzle</span>
                  </button>
                </div>
              ))}
            </div>

            {/* Demo Preview */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
              {/* Browser Header */}
              <div className="bg-gray-100 p-4 flex items-center space-x-3">
                <div className="flex space-x-2">
                  <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                  <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                  <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                </div>
                <div className="flex-1 bg-white rounded px-3 py-1">
                  <span className="font-open-sans font-body-normal text-xs text-text-secondary">
                    {activeDemo === 'dashboard' ? 'panel.cafeotomasyonu.com' : 
                     activeDemo === 'qr-menu' ? 'menu.cafeotomasyonu.com' :
                     activeDemo === 'pos' ? 'panel.cafeotomasyonu.com' :
                     activeDemo === 'mobile' ? 'online.cafeotomasyonu.com' : 'cafeotomasyonu.com'}
                  </span>
                </div>
              </div>

              {/* Demo Content */}
              <div className="p-6">
                {activeDemo === 'dashboard' && (
                  <div className="space-y-6">
                    {/* Stats Cards */}
                    <div className="grid grid-cols-2 gap-4">
                      <div className="bg-blue-50 p-4 rounded-lg">
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="font-open-sans font-body-normal text-sm text-text-secondary">
                              Günlük Satış
                            </p>
                            <p className="font-poppins font-heading-bold text-xl text-blue-600">
                              {mockDashboardData.todaySales}
                            </p>
                          </div>
                          <Icon name="TrendingUp" size={24} className="text-blue-600" />
                        </div>
                      </div>
                      
                      <div className="bg-green-50 p-4 rounded-lg">
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="font-open-sans font-body-normal text-sm text-text-secondary">
                              Aktif Siparişler
                            </p>
                            <p className="font-poppins font-heading-bold text-xl text-green-600">
                              {mockDashboardData.activeOrders}
                            </p>
                          </div>
                          <Icon name="Clock" size={24} className="text-green-600" />
                        </div>
                      </div>
                    </div>

                    {/* Recent Orders */}
                    <div>
                      <h4 className="font-poppins font-heading-semibold text-lg text-foreground mb-4">
                        Son Siparişler
                      </h4>
                      <div className="space-y-3">
                        {mockDashboardData.recentOrders.map((order, index) => (
                          <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                            <div className="flex-1">
                              <div className="flex items-center space-x-2">
                                <span className="font-inter font-accent-semibold text-sm text-foreground">
                                  {order.id}
                                </span>
                                <span className="font-open-sans font-body-normal text-xs text-text-secondary">
                                  {order.customer}
                                </span>
                              </div>
                              <p className="font-open-sans font-body-normal text-xs text-text-secondary">
                                {order.items}
                              </p>
                            </div>
                            <div className="text-right">
                              <p className="font-poppins font-heading-semibold text-sm text-foreground">
                                {order.amount}
                              </p>
                              <span className={`inline-block px-2 py-1 rounded-full text-xs font-inter font-accent-medium ${
                                order.status === 'Teslim Edildi' ? 'bg-green-100 text-green-600' :
                                order.status === 'Hazırlanıyor'? 'bg-yellow-100 text-yellow-600' : 'bg-blue-100 text-blue-600'
                              }`}>
                                {order.status}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {activeDemo === 'qr-menu' && (
                  <div className="space-y-6">
                    <div className="text-center">
                      <div className="w-32 h-32 bg-gray-200 rounded-lg mx-auto mb-4 flex items-center justify-center">
                        <Icon name="QrCode" size={64} className="text-primary" />
                      </div>
                      <h4 className="font-poppins font-heading-semibold text-lg text-foreground mb-2">
                        QR Kod ile Menü
                      </h4>
                      <p className="font-open-sans font-body-normal text-sm text-text-secondary">
                        Müşterileriniz telefon kamerası ile okutup menüyü görüntüleyebilir
                      </p>
                    </div>
                    
                    <div className="grid grid-cols-2 gap-4">
                      <div className="bg-purple-50 p-4 rounded-lg text-center">
                        <Icon name="Eye" size={24} className="text-purple-600 mx-auto mb-2" />
                        <p className="font-inter font-accent-semibold text-sm text-foreground">
                          2,340
                        </p>
                        <p className="font-open-sans font-body-normal text-xs text-text-secondary">
                          Günlük görüntülenme
                        </p>
                      </div>
                      
                      <div className="bg-orange-50 p-4 rounded-lg text-center">
                        <Icon name="ShoppingCart" size={24} className="text-orange-600 mx-auto mb-2" />
                        <p className="font-inter font-accent-semibold text-sm text-foreground">
                          %12.4
                        </p>
                        <p className="font-open-sans font-body-normal text-xs text-text-secondary">
                          Dönüşüm oranı
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {activeDemo === 'pos' && (
                  <div className="space-y-6">
                    <div className="bg-green-50 p-6 rounded-lg">
                      <div className="flex items-center justify-between mb-4">
                        <h4 className="font-poppins font-heading-semibold text-lg text-foreground">
                          Sipariş #1250
                        </h4>
                        <span className="bg-green-100 text-green-600 px-3 py-1 rounded-full font-inter font-accent-semibold text-sm">
                          Aktif
                        </span>
                      </div>
                      
                      <div className="space-y-3">
                        <div className="flex justify-between">
                          <span className="font-open-sans font-body-normal text-text-secondary">
                            2x Americano
                          </span>
                          <span className="font-inter font-accent-semibold text-foreground">
                            ₺30
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="font-open-sans font-body-normal text-text-secondary">
                            1x Cheesecake
                          </span>
                          <span className="font-inter font-accent-semibold text-foreground">
                            ₺20
                          </span>
                        </div>
                        <div className="border-t border-green-200 pt-3 flex justify-between">
                          <span className="font-poppins font-heading-semibold text-foreground">
                            Toplam
                          </span>
                          <span className="font-poppins font-heading-bold text-xl text-green-600">
                            ₺50
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="grid grid-cols-2 gap-4">
                      <button className="bg-primary text-white p-4 rounded-lg font-poppins font-cta-semibold">
                        Nakit Ödeme
                      </button>
                      <button className="bg-blue-500 text-white p-4 rounded-lg font-poppins font-cta-semibold">
                        Kart Ödeme
                      </button>
                    </div>
                  </div>
                )}

                {activeDemo === 'mobile' && (
                  <div className="space-y-6">
                    <div className="bg-gradient-to-br from-primary to-secondary p-6 rounded-lg text-white text-center">
                      <Icon name="Smartphone" size={48} className="mx-auto mb-4" />
                      <h4 className="font-poppins font-heading-semibold text-lg mb-2">
                        Mobil Uygulama
                      </h4>
                      <p className="font-open-sans font-body-normal text-sm opacity-90">
                        iOS ve Android için optimize edilmiş uygulama
                      </p>
                    </div>
                    
                    <div className="grid grid-cols-2 gap-4">
                      <div className="text-center">
                        <div className="w-12 h-12 bg-gray-900 rounded-lg mx-auto mb-2 flex items-center justify-center">
                          <Icon name="Apple" size={24} color="white" />
                        </div>
                        <p className="font-inter font-accent-medium text-sm">App Store</p>
                      </div>
                      
                      <div className="text-center">
                        <div className="w-12 h-12 bg-green-500 rounded-lg mx-auto mb-2 flex items-center justify-center">
                          <Icon name="Smartphone" size={24} color="white" />
                        </div>
                        <p className="font-inter font-accent-medium text-sm">Google Play</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Right - Demo Request Form */}
          <div className="bg-white rounded-2xl p-8 shadow-xl">
            <div className="text-center mb-8">
              <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Icon name="Calendar" size={32} color="white" />
              </div>
              
              <h3 className="font-poppins font-heading-bold text-2xl text-foreground mb-2">
                Ücretsiz Demo Talep Edin
              </h3>
              
              <p className="font-open-sans font-body-normal text-text-secondary">
                Uzmanlarımız size özel demo sunumu hazırlayacak
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-2 gap-4">
                <Input
                  label="Adınız Soyadınız"
                  type="text"
                  placeholder="Mehmet Özkan"
                  value={formData.name}
                  onChange={(e) => handleInputChange('name', e.target.value)}
                  required
                />
                
                <Input
                  label="Telefon"
                  type="tel"
                  placeholder="0532 123 45 67"
                  value={formData.phone}
                  onChange={(e) => handleInputChange('phone', e.target.value)}
                  required
                />
              </div>

              <Input
                label="E-posta Adresi"
                type="email"
                placeholder="mehmet@ozkan.com"
                value={formData.email}
                onChange={(e) => handleInputChange('email', e.target.value)}
                required
              />

              <Input
                label="İşletme Adı"
                type="text"
                placeholder="Özkan Cafe"
                value={formData.businessName}
                onChange={(e) => handleInputChange('businessName', e.target.value)}
                required
              />

              <Select
                label="İşletme Türü"
                placeholder="İşletme türünüzü seçin"
                options={businessTypes}
                value={formData.businessType}
                onChange={(value) => handleInputChange('businessType', value)}
                required
              />

              <Select
                label="Mevcut Sistem"
                placeholder="Şu anda kullandığınız sistem"
                options={currentSystems}
                value={formData.currentSystem}
                onChange={(value) => handleInputChange('currentSystem', value)}
                required
              />

              <Select
                label="Tercih Ettiğiniz Saat"
                placeholder="Demo için uygun saatiniz"
                options={timeSlots}
                value={formData.preferredTime}
                onChange={(value) => handleInputChange('preferredTime', value)}
                required
              />

              <Button
                type="submit"
                variant="default"
                size="lg"
                fullWidth
                loading={isSubmitting}
                iconName="Calendar"
                iconPosition="left"
              >
                {isSubmitting ? 'Gönderiliyor...' : 'Demo Randevusu Al'}
              </Button>

              <div className="text-center">
                <p className="font-open-sans font-body-normal text-xs text-text-secondary">
                  Demo tamamen ücretsizdir. Kredi kartı bilgisi istenmez.
                </p>
              </div>
            </form>

            {/* Trust Indicators */}
            <div className="mt-8 pt-6 border-t border-gray-200">
              <div className="grid grid-cols-3 gap-4 text-center">
                <div>
                  <Icon name="Shield" size={24} className="text-green-600 mx-auto mb-2" />
                  <p className="font-inter font-accent-medium text-xs text-text-secondary">
                    %100 Güvenli
                  </p>
                </div>
                
                <div>
                  <Icon name="Clock" size={24} className="text-blue-600 mx-auto mb-2" />
                  <p className="font-inter font-accent-medium text-xs text-text-secondary">
                    15 Dakika
                  </p>
                </div>
                
                <div>
                  <Icon name="Users" size={24} className="text-purple-600 mx-auto mb-2" />
                  <p className="font-inter font-accent-medium text-xs text-text-secondary">
                    Uzman Desteği
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DemoSection;